import { render, staticRenderFns } from "./CrowdStaking.vue?vue&type=template&id=71e102e6&scoped=true&"
import script from "./CrowdStaking.vue?vue&type=script&lang=js&"
export * from "./CrowdStaking.vue?vue&type=script&lang=js&"
import style0 from "./CrowdStaking.vue?vue&type=style&index=0&id=71e102e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e102e6",
  null
  
)

export default component.exports